import { ITask } from '../interface/tasks';
import { UserType } from './constants';

export const currentUserHasRightsToCriticalTask = (
  task: ITask,
  userType: string | undefined,
  userId: string | undefined,
) => {
  if (userType === UserType.ADMIN) return true;

  // NORMAL users always have access unless hasMatterAccess is explicitly false
  if (userType === UserType.NORMAL) {
    return task?.hasMatterAccess !== false;
  }

  // RESTRICTED users must be responsible AND hasMatterAccess must be true
  if (userType === UserType.RESTRICTED) {
    const isResponsible =
      task?.responsibleUserId === userId ||
      (task?.otherResponsibleUsers as unknown as { userId: string }[])?.some(
        (x) => x.userId === userId,
      );
    return isResponsible && task?.hasMatterAccess === true;
  }
  return false;
};
